import { useMemo, useState } from 'react';
import { Box, Button, Chip, CircularProgress, Stack, TextField, Typography } from '@mui/material';

export const QuickBidBar = ({
  precioVigente,
  minDecremento,
  disabled,
  sending,
  FormatPrice,
  onPreview,
  onSubmit,
}) => {
  const chips = useMemo(() => {
    const vigente = Number(precioVigente) || 0;
    const step = Number(minDecremento) || 0;
    const items = [];
    if (step > 0) {
      items.push({ label: `−$ ${FormatPrice(step)}`, value: vigente - step });
      items.push({ label: `−$ ${FormatPrice(step * 2)}`, value: vigente - step * 2 });
    }
    const pct5 = vigente * 0.05;
    items.push({ label: '−5 %', value: vigente - pct5 });
    return items.filter((item) => item.value > 0 && item.value < vigente);
  }, [precioVigente, minDecremento, FormatPrice]);

  const [otro, setOtro] = useState('');
  const [selected, setSelected] = useState(null);
  const proposed = selected ?? (otro !== '' ? Number(String(otro).replace(',', '.')) : null);
  const vigente = Number(precioVigente) || 0;
  const tooHigh = proposed !== null && !Number.isNaN(proposed) && proposed >= vigente;
  const invalid = proposed === null || Number.isNaN(proposed) || proposed <= 0 || tooHigh;

  const pick = (value) => {
    setSelected(value);
    setOtro('');
    if (onPreview) onPreview(value);
  };

  return (
    <Box>
      <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" sx={{ mb: 1.5 }}>
        {chips.map((chip) => (
          <Chip
            key={chip.label}
            size="small"
            label={chip.label}
            color={selected === chip.value ? 'primary' : 'default'}
            onClick={() => pick(chip.value)}
            disabled={disabled}
            sx={{ minHeight: 40, px: 1 }}
          />
        ))}
      </Stack>
      <TextField
        size="small"
        fullWidth
        label="Otro"
        value={otro}
        disabled={disabled}
        onChange={(event) => {
          setOtro(event.target.value);
          setSelected(null);
          const num = Number(String(event.target.value).replace(',', '.'));
          if (onPreview && !Number.isNaN(num)) onPreview(num);
        }}
        onKeyDown={(event) => {
          if (event.key === 'Enter' && !invalid && !disabled && onSubmit) {
            onSubmit(proposed);
          }
        }}
        helperText={`Debe ser menor a $ ${FormatPrice(vigente)}`}
        error={tooHigh}
      />
      <Button
        fullWidth
        variant="contained"
        sx={{ mt: 1.5 }}
        disabled={disabled || sending || invalid}
        onClick={() => onSubmit(proposed)}
        aria-label={invalid ? 'Ofertar' : `Ofertar ${FormatPrice(proposed)}`}
      >
        {sending ? <CircularProgress size={16} color="inherit" /> : `Ofertar $ ${invalid ? '—' : FormatPrice(proposed)}`}
      </Button>
    </Box>
  );
};
